export default __webpack_public_path__ + "d8470a119dea472af12cee1f559a57c2.png";